/* eslint-disable lines-between-class-members */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';

import { Theme } from 'mewe/constants';
import dispatcher from 'mewe/dispatcher';
import { openFtueRecommendations } from 'mewe/utils/dialogs-common';

export default class SidebarLeftMyworld extends Component {
  @service account;
  @service dynamicDialogs;

  @action
  openPublicDirectoryDialog() {
    this.dynamicDialogs.openDialog('browse-communities-dialog', {
      theme: Theme.GROUP,
    });
  }

  @action
  openInvitationsDialog() {
    dispatcher.dispatch('contact', 'openContactInvitationDialog');
  }

  @action
  openInterestsPicker() {
    openFtueRecommendations(this.dynamicDialogs, 'myworld-sidebar');
  }
}
